/**
 * Portfolio Selector Component.
 * 
 * Displays a dropdown to select the active portfolio.
 * Shows portfolio name, type, and primary indicator.
 */

import { FormControl, InputLabel, Select, MenuItem, Chip, Box, Tooltip } from '@mui/material';
import { usePortfolio } from '../contexts/PortfolioContext';

export function PortfolioSelector() {
  const { selectedPortfolioId, portfolios, setSelectedPortfolioId, isLoading } =
    usePortfolio();

  if (isLoading || portfolios.length === 0) {
    return null;
  }

  return (
    <FormControl size="small" sx={{ minWidth: 250 }}>
      <InputLabel id="portfolio-select-label">Portfolio</InputLabel>
      <Select
        labelId="portfolio-select-label"
        id="portfolio-select"
        value={selectedPortfolioId || ''}
        label="Portfolio"
        onChange={(e) => setSelectedPortfolioId(e.target.value)}
        sx={{ backgroundColor: 'background.paper' }}
      >
        {portfolios.map((portfolio) => (
          <MenuItem key={portfolio.portfolioId} value={portfolio.portfolioId}>
            <Box display="flex" alignItems="center" gap={1} width="100%">
              <span>{portfolio.name}</span>
              <Tooltip
                title={
                  portfolio.portfolioType === 'LIVE'
                    ? 'LIVE portfolios represent real capital backed by actual brokerage accounts. Recommendations apply to real money, but trades are executed manually.'
                    : 'SANDBOX portfolios use virtual capital for testing and research. Perfect for exploring strategies without risking real money.'
                }
                arrow
              >
                <Chip
                  label={portfolio.portfolioType}
                  size="small"
                  color={portfolio.portfolioType === 'LIVE' ? 'primary' : 'default'}
                  sx={{ height: 20, fontSize: '0.7rem' }}
                />
              </Tooltip>
              {portfolio.isPrimary && (
                <Chip
                  label="Primary"
                  size="small"
                  color="secondary"
                  sx={{ height: 20, fontSize: '0.7rem' }}
                />
              )}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

